import Vue from 'vue'
import Vuex from 'vuex'

const fb = require('./firebase')
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // Vuetify drawer
        drawer: true,
        // snack-bar / Toast
        snackBar: false,
        snackColor: 'info',
        snackText: 'hello',
        snackMultiLine: false,
        snackTimeout: 5000,
        // progress bar hide/show
        progressBar: false,
        // Firebase data buffer
        devices: {},
        groups: {},
        templates: {},
        users: {},
        statuses: {},
        // Order form data
        order: {},
        orderFormFields: ['business', 'createdAt', 'cashBackEnabled', 'cashBackLimitAmount', 'dinersEnabled', 'jcbEnabled', 'motoEnabled', 'maestroEnabled', 'manualLimitAmount', 'masterCardEnabled', 'promptReferenceEnabled', 'swipeLimitAmount', 'tipEnabled', 'visaEnabled', 'visaElectronEnabled', 'businessCity', 'businessCountry', 'businessLine1', 'businessLine2', 'businessState', 'businessPostCode', 'contactEmail', 'contactPhone', 'contactName', 'deviceName', 'deviceType', 'group', 'industry', 'macKey', 'apiOnly', 'apiUsername', 'apiPassword', 'merchantId', 'receiptFooter1', 'receiptFooter2', 'receiptFooter3', 'receiptFooter4', 'receiptFooter5', 'receiptHeader1', 'receiptHeader2', 'receiptHeader3', 'receiptHeader4', 'receiptHeader5', 'reference', 'serial', 'shippingCity', 'shippingCountry', 'shippingLine1', 'shippingLine2', 'shippingState', 'shippingPostCode', 'shippingReference', 'showDeviceName', 'status', 'terminalId'],
        activeNewOrderId: '',
        activeOrderIsDeleted: false,
        searchPhrase: ''
    },
    getters: {
        getGroupList(state) { return Object.values(state.groups) },
        getOrder(state) { return state.order },
        getActiveOrderIsDeleted (state) { return state.activeOrderIsDeleted },
        getActiveNewOrderId (state) { return state.activeNewOrderId },
        getSearch (state) { return state.searchPhrase }
    },
    mutations: {
        setDrawer(state, val) {
            state.drawer = val
        },
        showSnack(state, val) {
            state.snackText = val
            state.snackBar = true
        },
        showProgress(state) {
            state.progressBar = true
        },
        hideProgress(state) {
            state.progressBar = false
        },
        updateDevices(state, val) {
            if (val[1] !== undefined) {
                val[1].id = val[0]
                Vue.set(state.devices, val[0], val[1])
            }
        },
        updateStatuses(state, val) {
            if (val[1] !== undefined) {
                val[1].id = val[0]
                Vue.set(state.statuses, val[0], val[1])
            }
        },
        updateGroups(state, val) {
            if (val[1] !== undefined) {
                val[1].id = val[0]
                Vue.set(state.groups, val[0], val[1])
            }
        },
        deleteGroup(state, val) {
            Vue.delete(state.groups, val)
        },
        updateTemplates(state, val) {
            if (val[1] !== undefined) {
                val[1].id = val[0]
                Vue.set(state.templates, val[0], val[1])
            }
        },
        updateUsers(state, val) {
            if (val[1] !== undefined) {
                val[1].id = val[0]
                Vue.set(state.users, val[0], val[1])
            }
        },
        setOrder (state, val) { state.order = val },
        updateOrder (state, val) { Vue.set(state.order, val[0], val[1]) },
        updateSearch (state, val) {
            state.searchPhrase = val
        }
    },
    actions: {
        isUserLoggedIn() {
            let user = fb.auth.currentUser
            if (fb.auth.currentUser === null || fb.auth.currentUser === undefined) {
                return false
            }
            return !!user
        },
        addNewGroup({commit}, val) {
            // val = group name
            if (val !== '' && val !== undefined) {
                commit('showProgress')
                let newGroup = {
                    name: val,
                    parent: '',
                    description: '',
                    created_at: new Date(),
                    updated_at: new Date(),
                    users: [fb.auth.currentUser.uid],
                    devices: [],
                    orders: []
                }
                fb.groupsCollection.add(newGroup).then(
                    (group) => {
                        commit('hideProgress')
                        commit('updateGroups', [group.id, newGroup])
                        commit('showSnack', 'New group "' + val + '" added.')
                    },
                    (err) => {
                        commit('hideProgress')
                        commit('showSnack', err.message + ' Please try again.')
                    })
            } else {
                commit('showSnack', 'Please enter a new Group name.')
            }
        },
        removeGroup({commit}, val) {
            if (val !== '' && val !== undefined) {
                commit('showProgress')

                fb.groupsCollection.doc(val).delete()
                    .then(() => {
                        commit('hideProgress')
                        commit('deleteGroup', val)
                    })
            }
        },
        fetchAll({commit, state}) {
            commit('showProgress')
            fb.groupsCollection.where('users', 'array-contains', fb.auth.currentUser.uid)
                .onSnapshot(function (snapGroups) {
                    commit('hideProgress')
                    snapGroups.forEach((group) => {
                        commit('updateGroups', [group.id, group.data()])

                        let devices = group.data().devices

                        devices.forEach((device) => {
                            if (state.devices[device] === undefined) {
                                let deviceName = 'castles_' + device + '@kineticsmart.com'
                                commit('updateDevices', [deviceName, {}])
                                commit('showProgress')
                                fb.settingsCollection.doc(deviceName)
                                    .onSnapshot(function (snapSettings) {
                                        commit('hideProgress')
                                        commit('updateDevices', [snapSettings.id, snapSettings.data()])
                                    })
                            }
                        })

                        devices.forEach((device) => {
                            if (state.statuses[device] === undefined) {
                                let deviceName = 'castles_' + device + '@kineticsmart.com'
                                commit('updateStatuses', [device, {}])
                                commit('showProgress')

                                fb.statusesCollection
                                    .where('id', '==', deviceName)
                                    .orderBy('timestamp', 'desc')
                                    .limit(1)
                                    .get()
                                    .then((statuses) => {
                                        if (!statuses.empty) {
                                            statuses.forEach((status) => {
                                                commit('hideProgress')
                                                commit('updateStatuses', [device, status.data()])
                                            })
                                        }
                                    })

                            }
                        })

                        let users = group.data().users

                        users.forEach((user) => {
                            if (state.users[user] === undefined) {
                                commit('updateUsers', [user, {}])
                                commit('showProgress')
                                fb.usersCollection.doc(user)
                                    .onSnapshot(function (snapUser) {
                                        commit('hideProgress')
                                        commit('updateUsers', [snapUser.id, snapUser.data()])
                                    })
                            }
                        })

                        if (group.data().template) {
                            if (state.templates[group.data().template] === undefined) {
                                commit('showProgress')
                                fb.templatesCollection.doc(group.data().template)
                                    .onSnapshot(function (snapTemplate) {
                                        commit('hideProgress')
                                        commit('updateTemplates', [snapTemplate.id, snapTemplate.data()])
                                    })
                            }
                        }
                    })
                })
        },
        renameGroup ({commit, state}, val) {
            // val[0] = group ID, val[1] = new name
            commit('showProgress')
            fb.groupsCollection.doc(val[0])
                .set({'name': val[1], updated_at: new Date()}, {merge: true})
                .then(() => {
                    commit('hideProgress')
                    let newGroup = state.groups[val[0]]
                    newGroup['name'] = val[1]
                    commit('updateGroups', [val[0], newGroup])
                })
        },
        addUserToGroup ({commit}, val) {
            // val[0] = group ID, val[1] = email to add
            commit('showProgress')
            let groupId = val[0]
            let userEmail = val[1]
            if (userEmail === fb.auth.currentUser.email) {
                commit('showSnack', 'Cannot add yourself to this group.')
                commit('hideProgress')
                return
            }
            fb.usersCollection
                .where('email', '==', userEmail)
                .limit(1)
                .get()
                .then(function (users) {
                    if (users.empty) {
                        commit('hideProgress')
                        commit('showSnack', 'That email is not signed up on this service.')
                        return
                    }
                    users.forEach((user) => {
                        commit('showProgress')
                        if (user.exists) {
                            fb.groupsCollection.doc(groupId)
                                .get()
                                .then((group) => {
                                    commit('hideProgress')
                                    let users = group.data().users
                                    if (!users[user.id]) {
                                        users.push(user.id)
                                    }
                                    fb.groupsCollection.doc(groupId)
                                        .set({'users': users, updated_at: new Date()}, {merge: true})
                                        .then(() => {
                                            commit('showSnack', 'User added to Group.')
                                            commit('hideProgress')
                                        })
                                })
                        } else {
                            commit('hideProgress')
                        }
                    })
                })
        },
        addNewOrderToGroup ({commit, state}, val) {
            // val[0] = group ID, val[1] = new order business name
            commit('showProgress')
            fb.formsCollection
                .add({
                    'business': val[1],
                    'status': 'draft',
                    'group': val[0]
                })
                .then((doc) => {
                    state.activeNewOrderId = doc.id
                    commit('hideProgress')
                    commit('showSnack', 'Order initiated.')
                })
                .catch(function (error) {
                    commit('hideProgress')
                    commit('showSnack', 'Unable to add new order. ' + error.message)
                })
        },
        fetchOrder ({commit, state}, val) {
            commit('showProgress')
            fb.formsCollection.doc(val)
                .get()
                .then((order) => {

                    let o = order.data()
                    commit('hideProgress')
                    let output = {}
                    state.orderFormFields.forEach(function (field) {
                        output[field] = o[field]
                    })
                    output['id'] = val

                    // normalize new data
                    if (output.industry === undefined) { output['industry'] = 'retail' }
                    if (output.terminalId === undefined) { output['terminalId'] = '' }
                    if (output.deviceType === undefined) { output['deviceType'] = '' }
                    if (output.swipeLimitAmount === undefined) { output['swipeLimitAmount'] = 350 }
                    if (output.tipEnabled === undefined) { output['tipEnabled'] = false }
                    if (output.promptReferenceEnabled === undefined) { output['promptReferenceEnabled'] = false }
                    if (output.receiptHeader1 === undefined) { output['receiptHeader1'] = output.business }
                    if (output.cashBackEnabled === undefined) {
                        output['cashBackEnabled'] = true
                        output['cashBackLimitAmount'] = 100
                    }
                    if (output.motoEnabled === undefined) {
                        output['motoEnabled'] = false
                        output['manualLimitAmount'] = 500
                    }
                    if (output.visaEnabled === undefined) {
                        output['visaEnabled'] = true
                        output['visaElectronEnabled'] = true
                        output['mastercardEnabled'] = true
                        output['maestroEnabled'] = true
                        output['jcbEnabled'] = true
                        output['dinersEnabled'] = true
                    }

                    commit('hideProgress')
                    commit('setOrder', output)
                })
        },
        saveOrderForm ({commit, state}) {
            commit('showProgress')
            let order = {}
            state.orderFormFields.forEach((field) => {
                if (state.order[field] !== undefined) {
                    order[field] = state.order[field]
                }
            })
            order['updatedAt'] = new Date()
            order['id'] = state.order.id

            fb.formsCollection.doc(state.order.id).set(order)
                .then(() => {
                    commit('hideProgress')
                    commit('showSnack', 'Order saved.')
                })
        },
        shipOrderForm ({commit, dispatch, state}) {
            commit('updateOrder', ['status', 'ship'])
            let order = state.order
            // normalize the form data

            if (order.terminalId === '' || order.macKey === '') {
                if (order.deviceType.indexOf('demo_') !== -1) {
                    order.terminalId = '33420008'
                    order.merchantId = '010003382'
                    order.macKey = '0123456789ABCDEF'
                }

                if (order.deviceType.indexOf('barclays_') !== -1) {
                    dispatch('orderFormGetTIDMAC', 'barclaycard')
                }

                if (order.deviceType.indexOf('aibms_') !== -1) {
                    dispatch('orderFormGetTIDMAC', 'aibms')
                }
            }

            dispatch('saveOrderForm')
        },
        orderFormGetTIDMAC ({commit, dispatch}, val) {
            commit('showProgress')

            fb.macStartKeysCollection
                .where('acquirer', '==', val)
                .where('claimed', '==', false)
                .orderBy('order')
                .limit(1)
                .get()
                .then((startMacs) => {
                    commit('hideProgress')
                    startMacs.forEach(function (doc) {
                        let availableKey = doc.data()
                        commit('updateOrder', ['macKey', availableKey.merchant_master_key])
                        commit('updateOrder', ['terminalId', availableKey.terminal_id])

                        fb.macStartKeysCollection.doc(doc.id).update({
                            claimed: true
                        })

                        dispatch('saveOrderForm')
                    })
                })
                .catch(function (error) {
                    commit('hideProgress')
                    commit('showSnack', error.message + ' Please try again.')
                })
        },
        deleteOrderForm ({commit, state}, val) {
            commit('showProgress')

            fb.formsCollection.doc(val).delete()
                .then(function () {
                    commit('hideProgress')
                    commit('showSnack', 'Order deleted.')
                    state.activeOrderIsDeleted = true
                })
                .catch(function (error) {
                    commit('hideProgress')
                    commit('showSnack', error.message + ' Please try again.')
                })
        },
        saveSearch ({commit}, val) {
            commit('updateSearch', val)
        }
    }
})
